import React from "react";
import { Link } from "react-router-dom";
import { BookOpen } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
        <Link to="/" className="inline-flex items-center gap-2 text-primary" data-testid="terms-home-link">
          <BookOpen className="h-5 w-5" />
          <span className="font-serif text-lg font-black tracking-tight">DocCircle</span>
        </Link>
        <p className="mt-16 text-xs uppercase tracking-[0.25em] text-primary">Legal</p>
        <h1 className="mt-4 font-serif text-4xl lg:text-5xl font-black tracking-tight">Terms of Service</h1>
        <p className="mt-6 text-sm text-muted-foreground">
          Last updated: coming soon · Effective on account creation
        </p>

        <div className="mt-12 space-y-8 text-[15px] leading-relaxed text-foreground/90">
          <section>
            <h2 className="font-serif text-xl font-black tracking-tight text-foreground">Our promise</h2>
            <p className="mt-3">
              DocCircle exists to keep doctoral candidates from doing the hardest years of their careers alone.
              These terms set out how you use the platform and how we, in turn, treat your time and your work.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-black tracking-tight text-foreground">Your account</h2>
            <p className="mt-3">
              You keep your credentials confidential and are responsible for activity on your account.
              You warrant that the information you provide about your program, university, and research is accurate.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-black tracking-tight text-foreground">Your work stays yours</h2>
            <p className="mt-3">
              Anything you upload — drafts, notes, milestones, private reflections — remains your intellectual property.
              We store it to render your dashboard and journey. We do not train models on it or sell it to third parties.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-black tracking-tight text-foreground">Conduct</h2>
            <p className="mt-3">
              DocCircle is a scholarly space. Harassment, plagiarism, and doxxing are grounds for suspension.
              We reserve the right to remove content that violates the norms of academic integrity.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-black tracking-tight text-foreground">Availability & changes</h2>
            <p className="mt-3">
              The full, final Terms of Service will be published before Phase 2 launches (community features).
              This is a working placeholder while we complete the identity and journey layer.
              We will notify you by email of any material change to these terms.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-xl font-black tracking-tight text-foreground">Contact</h2>
            <p className="mt-3">
              Questions? Reach the team at{" "}
              <a href="mailto:hello@doccircle.com" className="text-primary underline underline-offset-4">
                hello@doccircle.com
              </a>
              .
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-border">
          <Link to="/" className="text-sm text-primary underline underline-offset-4" data-testid="terms-back-link">
            ← Back to DocCircle
          </Link>
        </div>
      </div>
    </div>
  );
}
